import React from "react";
import Right from "@material-ui/icons/NavigateNext";
import Left from "@material-ui/icons/NavigateBefore";

import rowena from "../assets/img/chars/rowena.png";
import lucien from "../assets/img/chars/lucien.png";
import ivor from "../assets/img/chars/ivor.png";
import edwin from "../assets/img/chars/edwin.png";
import larkin from "../assets/img/chars/larkin.png";
import evie from "../assets/img/chars/evie.png";
import cirrus from "../assets/img/chars/cirrus.png";
import reginald from "../assets/img/chars/reginald.png";
import opal from "../assets/img/chars/opal.png";
import nigel from "../assets/img/chars/nigel.png";

import rowenaS from "../assets/img/chars/rowena-s.png";
import lucienS from "../assets/img/chars/lucien-s.png";
import ivorS from "../assets/img/chars/ivor-s.png";
import edwinS from "../assets/img/chars/edwin-s.png";
import larkinS from "../assets/img/chars/larkin-s.png";
import evieS from "../assets/img/chars/evie-s.png";
import cirrusS from "../assets/img/chars/cirrus-s.png";
import reginaldS from "../assets/img/chars/reginald-s.png";
import opalS from "../assets/img/chars/opal-s.png";
import nigelS from "../assets/img/chars/nigel-s.png";

export const Characters = () => {
  const [charDivs, setCharDivs] = React.useState([]);
  const [selected, setSelected] = React.useState(0);
  const [circles, setCircles] = React.useState([]);
  const [anim, setAnim] = React.useState("slideIn2");

  const chars = [
    {
      name: "rowena",
      img: rowena,
      imgS: rowenaS,
      desc:
        "The former chancellor of Welkin who was executed by Ivor for treason. Rowena’s resolute will to raise her son keeps her spirit bound to this world as a revenant.",
    },
    {
      name: "lucien",
      imgS: lucienS,
      img: lucien,
      desc:
        "A crafty politician plotting a coup to dethrone a tyrant. Lucien plans to use his charm and clout as part of Welkin’s council to change the lives of all who reside within.",
    },
    {
      name: "ivor",
      imgS: ivorS,
      img: ivor,
      desc:
        "A prison warden who rules mankind’s last refuge with an iron fist. Ivor used his magic to lift Welkin into the sky protecting and trapping those with him from the venomous miasma below.",
    },
    {
      name: "edwin",
      imgS: edwinS,
      img: edwin,
      desc:
        "Rowena’s son who is cruelly imprisoned by Ivor to torment his mother. Good natured and strong-willed like his mother, Edwin is watched over by Lucien who promises Rowena he can help free him.",
    },
    {
      name: "larkin",
      imgS: larkinS,
      img: larkin,
      desc:
        "The current chancellor of Welkin and Ivor’s right-hand man. Aside from his disdain toward Lucien, Larkin is a taciturn leader.",
    },
    {
      name: "evie",
      imgS: evieS,
      img: evie,
      desc:
        "A sullen survivor who works inside Welkin’s warehouse. Evie was given a ticket to board Welkin from her older brother who stayed on the miasma ravaged ground below.",
    },
    {
      name: "cirrus",
      imgS: cirrusS,
      img: cirrus,
      desc:
        "An eccentric artist who views the world from an askew perspective. Cirrus is driven by visions of creating his masterpiece.",
    },
    {
      name: "reginald",
      imgS: reginaldS,
      img: reginald,
      desc:
        "An elder statesman frustrated with the system. Reginald often tries, but has so far failed to steer the council to vote on proposals that oppose Ivor.",
    },
    {
      name: "nigel",
      imgS: nigelS,
      img: nigel,
      desc:
        "A senior councilmember and staunch supporter of Ivor. Nigel was handpicked by Ivor to serve on the council and is suspicious of Lucien’s loyalties.",
    },
    {
      name: "opal",
      imgS: opalS,
      img: opal,
      desc:
        "A socialite and senior councilmember who is apathetic about her responsibilities. Opal adores the influence she is granted by the council, but finds politics to be blasé. ",
    },
  ];

  const changePic = (type) => {
    if (type === "next") {
      setAnim("slideIn2");
      if (selected === chars.length - 1) {
        setSelected(0);
      } else {
        setSelected(selected + 1);
      }
    } else {
      setAnim("slideIn");
      if (selected === 0) {
        setSelected(chars.length - 1);
      } else {
        setSelected(selected - 1);
      }
    }
  };

  const makeChars = (chrs) => {
    setCharDivs(
      chrs.map((e, i) => {
        return (
          <div
            className={`char flex row`}
            key={i}
            style={{ animation: anim + " 0.6s ease-out forwards" }}
          >
            <img
              src={e.img}
              alt=""
              className={`char-img shadowed hide-on-small`}
            />

            <div className="flex char-info-box">
              <h2 style={{ margin: "8px" }}>{e.name.toUpperCase()}</h2>
              <img
                className="hide-on-big"
                src={e.imgS}
                alt=""
                height="110px"
                style={{ borderRadius: "50%", border: "solid 1px #7600bb" }}
              />
              <p>{e.desc}</p>
            </div>
          </div>
        );
      })
    );
  };

  React.useEffect(() => {
    console.log("Rerendered chars");
    makeChars(chars);
  }, [selected]);

  return (
    <div className="flex start chars" id="characters">
      <div className="flex">
        <div className="flex row">
          <div
            className="btn viewer"
            style={{ margin: "16px", fontSize: "1rem" }}
            onClick={(e) => {
              changePic("prev");
            }}
          >
            <Left style={{ color: "white", fontSize: "2rem" }} />
          </div>
          <h2 className="chars-title">Characters</h2>
          <div
            className="btn viewer"
            style={{ margin: "16px", fontSize: "1rem" }}
            onClick={(e) => {
              changePic("next");
            }}
          >
            <Right style={{ color: "white", fontSize: "2rem" }} />
          </div>
        </div>
        <div className="flex row circles" style={{ padding: "8px" }}>
          <div
            onClick={() => {
              if (selected >= 0) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(0);
            }}
            className="circle"
            style={{ backgroundColor: selected === 0 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 1) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(1);
            }}
            className="circle"
            style={{ backgroundColor: selected === 1 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 2) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(2);
            }}
            className="circle"
            style={{ backgroundColor: selected === 2 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 3) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(3);
            }}
            className="circle"
            style={{ backgroundColor: selected === 3 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 4) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(4);
            }}
            className="circle"
            style={{ backgroundColor: selected === 4 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 5) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(5);
            }}
            className="circle"
            style={{ backgroundColor: selected === 5 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 6) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(6);
            }}
            className="circle"
            style={{ backgroundColor: selected === 6 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 7) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(7);
            }}
            className="circle"
            style={{ backgroundColor: selected === 7 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 8) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(8);
            }}
            className="circle"
            style={{ backgroundColor: selected === 8 ? "violet" : "black" }}
          ></div>
          <div
            onClick={() => {
              if (selected >= 9) {
                setAnim("slideIn");
              } else {
                setAnim("slideIn2");
              }
              setSelected(9);
            }}
            className="circle"
            style={{ backgroundColor: selected === 9 ? "violet" : "black" }}
          ></div>
        </div>
      </div>

      <div className="flex">{charDivs[selected]}</div>
    </div>
  );
};
